import { Col, Row } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";

import Textarea from "components/atoms/Textarea/Textarea";

function CostFormNotIncluded() {
  const intl = useIntl();
  return (
    <div>
      <Row className="mt-24 mb-8">
        <Col lg={2} md={3}>
          <div>
            <b>
              <FormattedMessage id="quotation-form.notIncluded" defaultMessage="Not Included" />
            </b>
          </div>
        </Col>
        <div className="w-392 custom-longfield-textarea">
          <Textarea
            name="costs.not_included_in_cost"
            placeholder={intl.formatMessage({
              id: "quotation-form.cancellationCharges",
              defaultMessage: "Cancellation charges / or e.g. waiting time",
            })}
            rows={2}
            className="text-body bg-white"
          />
        </div>
      </Row>
    </div>
  );
}

export default CostFormNotIncluded;
